<template lang="pug">
.modal-anotacao
    #modal-anotacao-interno
        el-form(
            label-position='left',
            :model='formDadosAnotacao',
            :rules='rules',
            ref='formAnotacao'
        )
            el-form-item(prop='comentario')
                el-input.modal-anotacao-interno--textarea(
                    ref='comentarioInput',
                    type='textarea',
                    :maxlength='maxLength',
                    v-model='formDadosAnotacao.comentario',
                    :placeholder="$t('mensagens.menuMapa.placeholder.insiraComentarioAqui')"
                )

                .contador-palavra
                    | {{ caracteresRestante }} {{ $t('mensagens.menuMapa.observacoes.caracteresRestantes') }}

            el-form-item(:label="$t('mensagens.menuMapa.labels.corTexto')", prop='style.color')
                el-color-picker(v-model='formDadosAnotacao.style.color')

            el-form-item(:label="$t('mensagens.menuMapa.labels.pesoFonte')", prop='style.fontWeight')
                el-select(v-model='formDadosAnotacao.style.fontWeight')
                    el-option(
                        v-for='fonte in fontes',
                        :key='fonte.value',
                        :label='fonte.label',
                        :value='fonte.value'
                    )

        .modal-anotacao-footer
            BaseButton(
                type='primary',
                @click='submeterAnotacao("formAnotacao")'
            )
                span(v-if='dadosDaAnotacaoEdicao') {{ $t('mensagens.menuMapa.labels.editar') }}
                span(v-else) {{ $t('mensagens.menuMapa.labels.inserirAnotacao') }}
</template>

<script>
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
export default {
    name: 'ModalAnotacao',
    components: {
        BaseButton
    },
    emits: ['adicionarAnotacao', 'closeDrawerMenuFerramentas'],
    props: {
        show: {
            type: Boolean
        },
        dadosDaAnotacaoEdicao: {
            type: Object
        },
        selectorIdMapa: {
            type: String,
            default: ''
        }
    },
    watch: {
        dadosDaAnotacaoEdicao: function () {
            if (this.dadosDaAnotacaoEdicao != null) {
                this.formDadosAnotacao = JSON.parse(
                    JSON.stringify(this.dadosDaAnotacaoEdicao)
                );
            }
        }
    },
    data() {
        return {
            maxLength: 500,
            formDadosAnotacao: {
                comentario: '',
                style: {
                    color: '#000000',
                    fontWeight: '400',
                    fontSize: '12px',
                    margin: '8px 10px 20px 14px'
                }
            },
            fontes: [
                {
                    value: 'bolder',
                    label: 'Negrito'
                },
                {
                    value: '400',
                    label: 'Normal'
                }
            ],
            rules: {
                comentario: [
                    {
                        required: true,
                        message: this.$t('mensagens.menuMapa.observacoes.necessarioInserirTexto'),
                        trigger: 'blur'
                    }
                ]
            }
        };
    },
    computed: {
        caracteresRestante() {
            return this.maxLength - this.formDadosAnotacao.comentario.length;
        }
    },
    methods: {
        submeterAnotacao(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    if (typeof this.formDadosAnotacao.comentario !== 'string') {
                        return;
                    }
                    let comentario = this.formDadosAnotacao.comentario.replace(
                        /\n/g,
                        '<br>'
                    );
                    const dados = {
                        comentario:
                            comentario.trim().charAt(0).toUpperCase() +
                            comentario.slice(1),
                        style: this.formDadosAnotacao.style
                    };
                    if (!this.dadosDaAnotacaoEdicao) {
                        this.$emit(
                            'adicionarAnotacao',
                            JSON.parse(JSON.stringify(dados))
                        );
                        this.$refs.formAnotacao.resetFields();
                    } else {
                        let elementoEdicao = document.getElementById(
                            `p-${this.dadosDaAnotacaoEdicao.idPopupAnotacao}`
                        );
                        elementoEdicao.setAttribute(
                            'style',
                            `
                            font-size: ${dados.style.fontSize};
                            color: ${dados.style.color};
                            font-weight: ${dados.style.fontWeight};
                            margin: ${dados.style.margin};
                        `
                        );
                        elementoEdicao.innerText = dados.comentario;
                        let elementoBotao = document.getElementById(
                            this.dadosDaAnotacaoEdicao.idPopupAnotacao
                        );
                        dados.idPopupAnotacao =
                            this.dadosDaAnotacaoEdicao.idPopupAnotacao;
                        elementoBotao.dadosDaAnotacao = JSON.parse(
                            JSON.stringify(dados)
                        );
                        this.$emit('closeDrawerMenuFerramentas');
                    }

                    this.formDadosAnotacao = {
                        comentario: '',
                        style: {
                            color: '#000000',
                            fontWeight: '400',
                            fontSize: '12px',
                            margin: '8px 10px 20px 14px'
                        }
                    };
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        }
    }
};
</script>
<style lang="scss">
#modal-anotacao-interno {
    padding-left: 0.5rem;
    
    .el-input__inner {
        font-size: 11px;
    }

    .radio-tipo .el-form-item__content {
        display: flex;
        justify-content: flex-start;

        .el-radio {
            padding-right: 1rem;
        }
    }
}
.modal-anotacao {
    .modal-anotacao-footer {
        display: flex;
        justify-content: space-between;

        .el-button{
            width: 100%;
            margin-bottom: 1rem;
        }
    }
    .el-form {
        margin-bottom: 25px;
    }
    .modal-anotacao--titulo {
        display: flex;
        align-items: center;

        i {
            margin-right: 5px;
        }
    }
    .el-color-picker__trigger {
        width: 210px;
        height: 80%;
    }
    .el-color-picker__color {
        width: 87%;
        height: 90%;
        margin-top: 1.1px;
    }
    .el-color-picker__icon {
        left: 92.2%;
        width: 10%;
        height: 65%;
        font-size: 16px;
        background: var(--primary);
        color: var(--white) !important;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 2px;
        &::before{
            height: 75%;
        }
    }

    .el-input--suffix .el-input__inner {
        width: 210px;
        height: 31px;
    }

    .el-input__suffix {
        height: 50%;
        width: 10%;
        top: 10px;
        margin-right: 2px;
        background: var(--primary);
        border-radius: 2px;

        .el-input__icon {
            width: 22px;
            color: var(--white) !important;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .el-select__caret {
            font-size: 16px;
        }
    }
    .modal-anotacao-interno--textarea {
        .el-textarea__inner {
            min-height: 150px !important;
        }
    }
    textarea {
        font-size: 14px;
    }

    .contador-palavra {
        font-size: 13px;
        color: var(--gray);
        float: right;
        max-width: 160px;
    }
    .el-form-item__error {
        top: 84%;
    }
    .el-form-item__label {
        color: var(--black) !important;
        font-size: 14px;
        font-weight: normal !important;
        width: 120px;
    }
}
</style>
